import * as React from 'react';
import * as Dati from '../Dati';
import { Trad, Tipo, CampoNumero, CampoData, HTMLEditor, CampoNumeroConSegno } from '../components/';

interface ITipoCampoProps {
    InfoCampo: Dati.CInfoCampo;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnBlur?: (e: React.FormEvent<any> | string, valore?: any) => any;
    OnChangeDeroga: (e: React.FormEvent<any>, tipo: string, verso: string) => void;
    Valore: any;
    Richiesto?: boolean;
    Campo: string;
    CampoDatabase?: string;
    Minimo?: number;
    Massimo?: number;
    Neutro?: number;
    Derogabile?: boolean;
    DerogaVerso?: string;
    Scrittura?: boolean;
    ComponenteDopoEtichetta?: React.ReactNode;
}

interface ITipoCampoHTMLProps extends ITipoCampoProps {
    CampoWordMassimoUnaTabella?: boolean;
}

export class TipoCampoStringa extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Testo", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <input type="text" className="form-control" value={this.props.Valore} name={this.props.Campo} onChange={(e) => { this.props.OnChange(e) }} required={this.props.Richiesto != undefined ? this.props.Richiesto : false} onBlur={this.props.OnBlur} readOnly={this.props.Scrittura != undefined ? !this.props.Scrittura : false} />
                <span className="kt-input-icon__icon kt-input-icon__icon--right">
                    <span>
                        <i className="la la-edit"></i>
                    </span>
                </span>
            </div>
        </div>;
    }
}

export class TipoCampoCheckBox extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Testo", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            <div className="col-6">
                <label className="col-form-label">{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>{this.props.ComponenteDopoEtichetta}
            </div>
            <div className="col-6">
                <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--brand">
                    <label><input type="Checkbox" checked={this.props.Valore} name={this.props.Campo} onChange={this.props.OnChange} required={this.props.Richiesto != undefined ? this.props.Richiesto : false} onBlur={this.props.OnBlur} readOnly={this.props.Scrittura != undefined ? !this.props.Scrittura : false} /><span></span>
                    </label>
                </span>
            </div>
        </div>;
    }
}

export class TipoCampoTesto extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Testo", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <textarea className="form-control" value={this.props.Valore} name={this.props.Campo} onChange={(e) => { this.props.OnChange(e) }} rows={4} required={this.props.Richiesto != undefined ? this.props.Richiesto : false} onBlur={this.props.OnBlur} readOnly={this.props.Scrittura != undefined ? !this.props.Scrittura : false} />
            </div>
        </div>;
    }
}

export const TipoCampoHTML: React.FC<ITipoCampoHTMLProps> = (props) => {
    let etichetta = <label>{Trad.Trad(props.InfoCampo.Etichetta)}</label>;
    if (props.Derogabile != undefined && props.Derogabile) {
        etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (props.CampoDatabase != undefined ? props.CampoDatabase : "") + "]"} value={props.CampoDatabase != undefined ? props.CampoDatabase : ""} type="checkbox" onChange={(e) => props.OnChangeDeroga(e, "Testo", props.DerogaVerso || "")} /><span></span></label>;
    }

    return <div style={{ minHeight: 88 }}>
        {etichetta}{props.ComponenteDopoEtichetta}
        <div className="kt-input-icon kt-input-icon--right">
            <HTMLEditor Name={props.Campo} Value={props.Valore} OnChange={props.OnChange} CampoWordMassimoUnaTabella={props.CampoWordMassimoUnaTabella} />
        </div>
    </div>;
}

export class TipoCampoData extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Data", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="form-control">
                <CampoData ValoreInArrivo={false}
                    Name={this.props.Campo}
                    Id={this.props.Campo}
                    Valore={this.props.Valore}
                    OnChange={this.props.OnChange}
                    Scrittura={this.props.Scrittura}
                    Disabilitato={this.props.Scrittura == undefined ? false : !this.props.Scrittura} />
            </div>
        </div>;
    }
}

export class TipoCampoImporto extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Importo", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoNumero Id={this.props.Campo} Valore={this.props.Valore} OnChange={(e) => { this.props.OnChange(e) }} Name={this.props.Campo} CSS="form-control kt-input" Icona="la la-money" Minimo={this.props.Minimo} Massimo={this.props.Massimo} ValoreNeutro={this.props.Neutro} BarraLimiti={this.props.Massimo != undefined} Richiesto={this.props.Richiesto} OnBlur={this.props.OnBlur} Scrittura={this.props.Scrittura} />
            </div>
        </div>;
    }
}


export class TipoCampoNumeroConSegno extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Importo", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoNumeroConSegno Id={this.props.Campo} Valore={this.props.Valore} OnChange={(e) => { this.props.OnChange(e) }} Name={this.props.Campo} CSS="form-control kt-input" Icona="la la-money" Minimo={this.props.Minimo} Massimo={this.props.Massimo} ValoreNeutro={this.props.Neutro} BarraLimiti={this.props.Massimo != undefined} Richiesto={this.props.Richiesto} OnBlur={this.props.OnBlur} Scrittura={this.props.Scrittura} />
            </div>
        </div>;
    }
}



export class TipoCampoPercentuale extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        let etichetta = <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>;
        if (this.props.Derogabile != undefined && this.props.Derogabile) {
            etichetta = <label className="kt-checkbox kt-checkbox--solid kt-checkbox--metal" title={Trad.Trad("Richiesta deroga")}>{Trad.Trad(this.props.InfoCampo.Etichetta)}<input name={"ListaCampiDeroga[" + (this.props.CampoDatabase != undefined ? this.props.CampoDatabase : "") + "]"} value={this.props.CampoDatabase != undefined ? this.props.CampoDatabase : ""} type="checkbox" onChange={(e) => this.props.OnChangeDeroga(e, "Percentuale", this.props.DerogaVerso || "")} /><span></span></label>;
        }

        return <div style={{ minHeight: 88 }}>
            {etichetta}{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoNumero Id={this.props.Campo} Valore={this.props.Valore} OnChange={(e) => { this.props.OnChange(e) }} Name={this.props.Campo} CSS="form-control kt-input" Precisione={2} Icona="fa fa-percentage" Minimo={this.props.Minimo} Massimo={this.props.Massimo} ValoreNeutro={this.props.Neutro} BarraLimiti={this.props.Massimo != undefined} Richiesto={this.props.Richiesto} OnBlur={this.props.OnBlur} Scrittura={this.props.Scrittura} />
            </div>
        </div>;
    }
}


export class TipoCampoTipo extends React.Component<ITipoCampoProps, {}> {
    private dati: Dati.TDictTipo = {};
    public constructor(props: any) {
        super(props);
    }

    public render() {
        let MenuTendina = <select><option value="ERRORE">ERRORE</option></select>;
        if ((this.props.InfoCampo.TipoTabella == "" || this.props.InfoCampo.TipoTabella == null) && this.props.InfoCampo.TipoJSON != "") {
            this.dati = JSON.parse(this.props.InfoCampo.TipoJSON);
            MenuTendina = <Tipo Campo={this.props.Campo} Dati={this.dati} ID_ChiaveString={this.props.Valore || ""} OnAggiorna={this.props.OnChange} Disabilitato={this.props.Scrittura != undefined ? !this.props.Scrittura : false} OnBlur={this.props.OnBlur} />;
        }
        if (this.props.InfoCampo.TipoTabella != "" && (this.props.InfoCampo.TipoJSON == "" || this.props.InfoCampo.TipoJSON == null)) {
            MenuTendina = <Tipo Campo={this.props.Campo} URL={this.props.InfoCampo.TipoTabella} ID_ChiaveString={this.props.Valore || ""} OnAggiorna={this.props.OnChange} Disabilitato={this.props.Scrittura != undefined ? !this.props.Scrittura : false} OnBlur={this.props.OnBlur} />;
        }

        return <div style={{ minHeight: 88 }}>
            <label>{Trad.Trad(this.props.InfoCampo.Etichetta)}</label>{this.props.ComponenteDopoEtichetta}
            <div className="kt-input-icon kt-input-icon--right">
                {MenuTendina}
            </div>
        </div>;
    }
}

export class TipoCampoInfo extends React.Component<ITipoCampoProps, {}> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        let etichetta = <div className="kt-demo kt--font-danger">{Trad.Trad(this.props.InfoCampo.Etichetta)}</div>;
        return <div style={{ minHeight: 40 }}>
            {etichetta}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/TipiCampi.tsx